import * as styles from '../../assets/styles/eventOverview'
import QuantityStepper from '../../containers/QuantityStepper'
import { connect } from 'react-redux'
import { incrementItem, selectInventoryItems } from '../../actions/navigation'
import ContinueButton from './ContinueButton'
import { parseBoolean } from '../../utils/preloadedState'
import { calcTotalFeePrice } from '../../utils/calcCharges'
import { RESERVATION_TYPE, GUESTLIST_FREE_TYPE, REQUEST_TYPE } from '../../reducers/inventoryReducer'
import { isMultiInventoryRequestEnabled } from '../../selectors/eventSelector'

const { fonts_color_primary, fonts_color_secondary } = widgetInit.settings

const InventoryItem = ({
  inventoryItem,
  inventoryAvailabilities,
  inventoryCart,
  languageCode,
  currencyCode,
  isDisabled,
  textMinimumSpend,
  isFeesInPriceDisplayed,
  incrementItem,
  selectInventoryItem,
  selectedDate,
  selectedEventId,
  defaultServiceCharge,
  deviceSize,
  isMultiInventoryRequestEnabled,
  shouldShowRemainingInventory,
}) => {
  const { price, compText, inventoryId, inventoryType } = inventoryItem
  const { availabilityId } = inventoryAvailabilities[inventoryId]
  const { quantity } = inventoryCart.find(item => item.inventoryId === inventoryId)
  const { remainingQuantity } = inventoryAvailabilities[inventoryId]
  const maxQuantity = Math.min(inventoryItem.maxQuantity, remainingQuantity)

  const totalFeePrice = calcTotalFeePrice(inventoryItem, 1, price, defaultServiceCharge)
  const totalPrice = isFeesInPriceDisplayed ? price + totalFeePrice : price
  const currencyFormatter = new Intl.NumberFormat(languageCode, { style: 'currency', currency: currencyCode })

  const opacity = isDisabled ? '0.3' : '1'
  const isSmallResolutionDevice = deviceSize === 'small'
  const widthPercentages = isSmallResolutionDevice ? ['50%', '50%'] : ['45%', '55%']
  const shouldShowFeesInPrice = !!(isFeesInPriceDisplayed && totalFeePrice)

  const getHeaderText = (inventory, quantity) => {
    let headerText = ''
    const numGuests = quantity === 0 ? inventory.entryPerReservation : quantity * inventory.entryPerReservation

    if (numGuests <= 1) {
      headerText = 'For 1 guest'
    } else {
      headerText = `For ${numGuests} guests`
    }

    if (inventory.minQuantity > 1) {
      headerText = `${headerText}, ${inventory.minQuantity} tickets minimum`
    }

    if (inventory.inventoryType === RESERVATION_TYPE && inventory.minPrice) {
      const minDollarText = (function () {
        const minDollarAmount = quantity === 0 ? inventory.minPrice : quantity * inventory.minPrice
        const minDollarAmountFormatted = currencyFormatter.format(minDollarAmount)
        return `, ${minDollarAmountFormatted} ${textMinimumSpend}`
      })()
      headerText = `${headerText}${minDollarText}`
    }

    return headerText
  }

  if (inventoryType === REQUEST_TYPE && !isMultiInventoryRequestEnabled) {
    return (
      <div style={{ backgroundColor: isDisabled ? styles.rgbaWidgetBackground : styles.rgbaCellBackground, padding: '20px 16px' }}>
        <div
          style={{
            position: 'absolute',
            fontSize: '12px',
            fontWeight: '300',
            color: fonts_color_secondary,
            marginTop: '-7px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '506px',
            opacity,
          }}
          data-test="header-text"
        >
          Request only
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              fontSize: '18px',
              color: fonts_color_primary,
              flex: '1 1 auto',
              opacity,
            }}
          >
            {inventoryItem.inventoryName}
          </div>
          <ContinueButton
            aria-label="continue to checkout"
            disabled={isDisabled}
            onClick={() => {
              incrementItem(selectedDate, selectedEventId, inventoryId)
              selectInventoryItem(inventoryId, availabilityId)
            }}
          >
            Request
          </ContinueButton>
        </div>
      </div>
    )
  }

  if (inventoryType === REQUEST_TYPE && isMultiInventoryRequestEnabled) {
    return (
      <div style={{ backgroundColor: isDisabled ? styles.rgbaWidgetBackground : styles.rgbaCellBackground, padding: '20px 16px' }}>
        <div
          style={{
            fontSize: '12px',
            fontWeight: '300',
            color: fonts_color_secondary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '506px',
            opacity,
            marginBottom: '8px',
          }}
          data-test="header-text"
        >
          Request only
        </div>
        <div style={{ display: 'flex' }}>
          <div
            style={{
              fontSize: isSmallResolutionDevice ? '16px' : '18px',
              color: fonts_color_primary,
              flex: `0 0 ${widthPercentages[0]}`,
              opacity,
              marginTop: '4px',
              paddingRight: '10px',
            }}
          >
            {inventoryItem.inventoryName}
          </div>
          <div
            style={{
              flex: `0 0 ${widthPercentages[1]}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingRight: isSmallResolutionDevice ? '0' : '148px',
            }}
          >
            <QuantityStepper inventoryId={inventoryId} quantity={quantity} minQuantity={0} maxQuantity={Infinity} isDisabled={isDisabled} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ backgroundColor: isDisabled ? styles.rgbaWidgetBackground : styles.rgbaCellBackground, padding: '20px 16px' }}>
      <div
        style={{
          fontSize: '12px',
          fontWeight: '300',
          color: fonts_color_secondary,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '506px',
          opacity,
          marginBottom: '8px',
        }}
        data-test="header-text"
      >
        {getHeaderText(inventoryItem, quantity)}
      </div>
      <div style={{ display: 'flex' }}>
        <div
          style={{
            fontSize: isSmallResolutionDevice ? '16px' : '18px',
            color: fonts_color_primary,
            flex: `0 0 ${widthPercentages[0]}`,
            opacity,
            marginTop: '4px',
            paddingRight: '10px',
          }}
        >
          {inventoryItem.inventoryName}
        </div>
        <div
          style={{
            flex: `0 0 ${widthPercentages[1]}`,
            display: 'flex',
            justifyContent: 'space-between',
            paddingRight: isSmallResolutionDevice ? '0' : '148px',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <QuantityStepper
              inventoryId={inventoryId}
              quantity={quantity}
              minQuantity={0}
              maxQuantity={maxQuantity}
              isDisabled={isDisabled}
            />
            {shouldShowRemainingInventory && (
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: '300',
                  color: fonts_color_secondary,
                  marginTop: '3px',
                }}
              >
                {remainingQuantity} remaining
              </div>
            )}
          </div>
          <div
            style={{
              textAlign: 'right',
              marginTop: '4px',
              marginLeft: '8px',
              alignSelf: shouldShowFeesInPrice ? 'flex-end' : 'auto',
              opacity,
            }}
          >
            <div style={{ fontSize: '16px', color: fonts_color_primary }} data-test="price-text">
              {inventoryType === GUESTLIST_FREE_TYPE ? compText : currencyFormatter.format(totalPrice)}
            </div>
            {shouldShowFeesInPrice && (
              <div
                data-test="fees-in-price"
                style={{
                  fontSize: '12px',
                  fontWeight: '300',
                  color: fonts_color_secondary,
                  marginTop: '8px',
                }}
              >
                * Includes {currencyFormatter.format(totalFeePrice)} in fees
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  incrementItem: (date, eventId, inventoryId) => {
    dispatch(incrementItem(date, eventId, inventoryId))
  },
  selectInventoryItem: (inventoryId, availabilityId) => {
    dispatch(selectInventoryItems([{ inventoryId, availabilityId }]))
  },
})
const mapStateToProps = state => {
  const selectedEventId = state.userSelection.get('eventId')
  const event = state.entities.events.get(selectedEventId)

  return {
    languageCode: state.app.language,
    textMinimumSpend: state.widgetSettings.textMinimumSpend,
    inventoryCart: state.inventoryCart.cart,
    selectedDate: state.userSelection.get('date'),
    selectedEventId,
    isFeesInPriceDisplayed: parseBoolean(state.widgetSettings.isFeesInPriceDisplayed),
    defaultServiceCharge: state.venueInfo.venueDefaultServiceCharge,
    isMultiInventoryRequestEnabled: isMultiInventoryRequestEnabled(state),
    shouldShowRemainingInventory: event.get('shouldShowRemainingInventory'),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(InventoryItem)
